/**
 * Centralized Age Bracket Constants
 *
 * This file defines the consistent age brackets used throughout the application
 * for both patient preferences and provider service capabilities.
 */

export const AGE_BRACKETS = [
  { value: "18+", label: "Adults (18+)" },
  { value: "55+", label: "Seniors (55+)" },
] as const;

export const AGE_BRACKET_VALUES = AGE_BRACKETS.map((bracket) => bracket.value);

export const AGE_BRACKET_LABELS = AGE_BRACKETS.map((bracket) => bracket.label);

// Type definitions for type safety
export type AgeBracketValue = (typeof AGE_BRACKET_VALUES)[number];
export type AgeBracketOption = (typeof AGE_BRACKETS)[number];

// Helper functions
export const getAgeBracketLabel = (value: AgeBracketValue): string => {
  return (
    AGE_BRACKETS.find((bracket) => bracket.value === value)?.label || value
  );
};

export const isValidAgeBracket = (value: string): value is AgeBracketValue => {
  return AGE_BRACKET_VALUES.includes(value as AgeBracketValue);
};

// For backwards compatibility with existing code
export const AGE_GROUPS = AGE_BRACKETS;
